import { Card, CardBody, CardHeader, CardTitle } from "@filament/react/card";
import React, { ReactNode } from "react";
import * as styles from './Page.css';

type PageProps = {
    children: ReactNode;
    isFullWidth?: boolean;
    isFullHeight?: boolean;
}

const findSlot = (children: ReactNode, type: React.ElementType): ReactNode => {
    let found: ReactNode;
    React.Children.forEach(children, child => {
        if (React.isValidElement(child) && child.type === type) found = child;
    });
    return found;
};

export const Page = ({ isFullWidth = true, isFullHeight = true, children }: PageProps) => {
    const title = findSlot(children, Page.Title);
    const content = findSlot(children, Page.Content) ?? children;
    const panel = findSlot(children, Page.Panel);

    return (
        <div className={styles.page}>
            <div className={styles.content}>
                <Card className={[
                    isFullWidth ? styles.fullWidth : '',
                    isFullHeight ? styles.fullHeigth : ''
                ]}>
                    {title && (
                        <CardHeader className={styles.header}>
                            <CardTitle>{title}</CardTitle>
                        </CardHeader>
                    )}

                    <CardBody className={styles.cardBody}>
                        <div className={styles.scrollableContent}>
                            {content}
                        </div>
                    </CardBody>
                </Card>
            </div>

            {panel && <div className={styles.panel}>{panel}</div>}
        </div>
    )
}

Page.Title = ({ children }: { children: ReactNode }) => children;
Page.Content = ({ children }: { children: ReactNode }) => children;
Page.Panel = ({ children }: { children: ReactNode }) => children;